import React from 'react';
import Modal from "react-modal";
import styles from './consentModal.module.scss';

const modalStyles = {
  overlay: {
    backgroundColor: 'rgba(0,0,0,0.5)',
    zIndex: 1000,
  },
  content: {
    maxWidth: '600px',
    width: '90%',
    maxHeight: '80vh',
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    border: 'none',
    padding: 32,
    borderRadius: 24,
    overflow: 'auto',
  }
};

const ConsentModal = ({ isOpen, onClose }) => {
  return (
    <Modal
      ariaHideApp={false}
      isOpen={isOpen}
      style={modalStyles}
      onRequestClose={onClose}
    >
      <svg
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        onClick={onClose}
        style={{
          zIndex: 2,
          position: 'absolute',
          right: '12px',
          top: '12px',
          cursor: 'pointer'
        }}
      >
        <rect
          x="28.7266"
          y="8.72949"
          width="3.52711"
          height="28.2169"
          rx="1.76356"
          transform="rotate(45 28.7266 8.72949)"
          fill="#AFAFAB"
        />
        <rect
          x="8.77344"
          y="11.2236"
          width="3.52711"
          height="28.2169"
          rx="1.76356"
          transform="rotate(-45 8.77344 11.2236)"
          fill="#AFAFAB"
        />
      </svg>

      <div className={styles.modal}>
        <h2 className={styles.title}>Правила создания акций</h2>

        <div className={styles.content}>
          <p className={styles.intro}>
            Создавая акцию в системе Sagi, вы соглашаетесь соблюдать следующие правила:
          </p>

          <section className={styles.section}>
            <h3>1. Достоверность информации</h3>
            <ul>
              <li>Вся информация в акции должна быть правдивой и не вводящей в заблуждение</li>
              <li>Изображения должны соответствовать описанию акции</li>
              <li>Условия акции должны быть четко и ясно изложены</li>
              <li>Запрещается использование ложной или вводящей в заблуждение информации</li>
            </ul>
          </section>

          <section className={styles.section}>
            <h3>2. Запрещенный контент</h3>
            <ul>
              <li>Запрещены изображения и описания сексуального или порнографического характера</li>
              <li>Запрещен контент, содержащий насилие, жестокость или призывы к насилию</li>
              <li>Запрещена дискриминация по любым признакам (раса, пол, религия, национальность и др.)</li>
              <li>Запрещена пропаганда наркотиков, алкоголя несовершеннолетним, азартных игр</li>
              <li>Запрещены материалы, нарушающие законодательство Республики Казахстан</li>
            </ul>
          </section>

          <section className={styles.section}>
            <h3>3. Авторские права</h3>
            <ul>
              <li>Вы гарантируете, что имеете права на все используемые изображения</li>
              <li>Запрещено использование изображений, защищенных авторским правом, без разрешения правообладателя</li>
              <li>Вы несете ответственность за нарушение авторских прав третьих лиц</li>
            </ul>
          </section>

          <section className={styles.section}>
            <h3>4. Качество изображений</h3>
            <ul>
              <li>Изображения должны быть четкими и качественными</li>
              <li>Рекомендуемое разрешение: не менее 1200x800 пикселей</li>
              <li>Изображения не должны содержать водяные знаки других сервисов</li>
            </ul>
          </section>

          <section className={styles.section}>
            <h3>5. Ответственность</h3>
            <ul>
              <li><strong>Вы несете полную ответственность</strong> за содержание созданной акции</li>
              <li>Вы несете ответственность за соблюдение условий акции перед клиентами</li>
              <li>Администрация Sagi оставляет за собой право удалить акцию, нарушающую данные правила</li>
              <li>За неоднократное нарушение правил возможна блокировка аккаунта</li>
            </ul>
          </section>

          <section className={styles.section}>
            <h3>6. Модерация</h3>
            <ul>
              <li>Все акции проходят модерацию перед публикацией</li>
              <li>Администрация имеет право отклонить акцию без объяснения причин</li>
              <li>При обнаружении нарушений акция будет удалена без предварительного уведомления</li>
            </ul>
          </section>

          <p className={styles.footer}>
            Создавая акцию, вы подтверждаете, что ознакомились с правилами и принимаете на себя всю ответственность за размещаемый контент.
          </p>
        </div>

        <button className={styles.closeButton} onClick={onClose}>
          Понятно
        </button>
      </div>
    </Modal>
  );
};

export default ConsentModal;
